import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type DragIndicatorProps = IconComponentBaseProps;

export const DragIndicator = ({
  className,
  width = 12,
  height = 12,
  fill = defaultTheme.mantineColors.gray[7],
}: DragIndicatorProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_5452_49390"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5452_49390)">
        <path
          d="M4.50001 9.80763C4.27792 9.80763 4.0878 9.72855 3.92963 9.57038C3.77147 9.41222 3.69238 9.22209 3.69238 9.00001C3.69238 8.77792 3.77147 8.5878 3.92963 8.42963C4.0878 8.27147 4.27792 8.19238 4.50001 8.19238C4.72209 8.19238 4.91222 8.27147 5.07038 8.42963C5.22855 8.5878 5.30763 8.77792 5.30763 9.00001C5.30763 9.22209 5.22855 9.41222 5.07038 9.57038C4.91222 9.72855 4.72209 9.80763 4.50001 9.80763ZM7.50001 9.80763C7.27792 9.80763 7.0878 9.72855 6.92963 9.57038C6.77147 9.41222 6.69238 9.22209 6.69238 9.00001C6.69238 8.77792 6.77147 8.5878 6.92963 8.42963C7.0878 8.27147 7.27792 8.19238 7.50001 8.19238C7.72209 8.19238 7.91222 8.27147 8.07038 8.42963C8.22855 8.5878 8.30763 8.77792 8.30763 9.00001C8.30763 9.22209 8.22855 9.41222 8.07038 9.57038C7.91222 9.72855 7.72209 9.80763 7.50001 9.80763ZM4.50001 6.80763C4.27792 6.80763 4.0878 6.72855 3.92963 6.57038C3.77147 6.41222 3.69238 6.22209 3.69238 6.00001C3.69238 5.77792 3.77147 5.5878 3.92963 5.42963C4.0878 5.27147 4.27792 5.19238 4.50001 5.19238C4.72209 5.19238 4.91222 5.27147 5.07038 5.42963C5.22855 5.5878 5.30763 5.77792 5.30763 6.00001C5.30763 6.22209 5.22855 6.41222 5.07038 6.57038C4.91222 6.72855 4.72209 6.80763 4.50001 6.80763ZM7.50001 6.80763C7.27792 6.80763 7.0878 6.72855 6.92963 6.57038C6.77147 6.41222 6.69238 6.22209 6.69238 6.00001C6.69238 5.77792 6.77147 5.5878 6.92963 5.42963C7.0878 5.27147 7.27792 5.19238 7.50001 5.19238C7.72209 5.19238 7.91222 5.27147 8.07038 5.42963C8.22855 5.5878 8.30763 5.77792 8.30763 6.00001C8.30763 6.22209 8.22855 6.41222 8.07038 6.57038C7.91222 6.72855 7.72209 6.80763 7.50001 6.80763ZM4.50001 3.80763C4.27792 3.80763 4.0878 3.72855 3.92963 3.57038C3.77147 3.41222 3.69238 3.22209 3.69238 3.00001C3.69238 2.77792 3.77147 2.5878 3.92963 2.42963C4.0878 2.27147 4.27792 2.19238 4.50001 2.19238C4.72209 2.19238 4.91222 2.27147 5.07038 2.42963C5.22855 2.5878 5.30763 2.77792 5.30763 3.00001C5.30763 3.22209 5.22855 3.41222 5.07038 3.57038C4.91222 3.72855 4.72209 3.80763 4.50001 3.80763ZM7.50001 3.80763C7.27792 3.80763 7.0878 3.72855 6.92963 3.57038C6.77147 3.41222 6.69238 3.22209 6.69238 3.00001C6.69238 2.77792 6.77147 2.5878 6.92963 2.42963C7.0878 2.27147 7.27792 2.19238 7.50001 2.19238C7.72209 2.19238 7.91222 2.27147 8.07038 2.42963C8.22855 2.5878 8.30763 2.77792 8.30763 3.00001C8.30763 3.22209 8.22855 3.41222 8.07038 3.57038C7.91222 3.72855 7.72209 3.80763 7.50001 3.80763Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
